import axios from "axios";
import axios1 from "../config/axiosInstance";

const API_BASE_URL = "https://tourvn.runasp.net/api/booking"; // Cập nhật URL backend của bạn

export const bookingService = {
  getBookingById: async (bookingId) => {
    return await axios.get(`${API_BASE_URL}/${bookingId}`);
  },

  getBookingByUserId: async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/user/${userId}`);
    return response.data;
  },

  getBookingByUserIdPaging: async (
    userId,
    currentPage,
    pageSize = 5,
    tourName = "",
    status
  ) => {
    const params = new URLSearchParams({
      userId: userId,
      page: currentPage,
      pageSize: pageSize,
      tourName: tourName || "",
    });

    if (status) {
      params.append("status", status);
    }
    const response = await axios.get(
      `${API_BASE_URL}/user/paging?${params.toString()}`
    );
    return response.data;
  },
  getDiscountByCode: async (discountCode, tourId) => {
    try {
      const response = await axios.get(
        `https://tourvn.runasp.net/api/discounts/get-by-code`,
        {
          params: { discountCode, tourId },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || "Failed to fetch discount";
    }
  },

  cancelBooking: async (bookingId, reason) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/cancel`, {
        bookingId,
        reason,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || "Failed to cancel booking";
    }
  },

  getCancelPendingBookings: async (page, pageSize) => {
    return await axios1.get(
      `/booking/get-booking-pending?page=${page}&pageSize=${pageSize}`
    );
  },
  approveCancelBooking: async (bookingId) => {
    return await axios1.put(`/booking/approve-cancel/${bookingId}`);
  },
};
